import type { FunctionInfo, MessageTransport, SendMessageReturnValue } from "../message-transport.js";
import type ServiceWorkerFunctionInfo from "./function-info.js";

type SendMessageParams<I extends FunctionInfo> = Omit<MessageTransport<I>, "source">;

/**
 * @param message
 */
export function sendMessage<FunctionName extends keyof ServiceWorkerFunctionInfo>(
	message: {
		function: FunctionName;
	} & SendMessageParams<ServiceWorkerFunctionInfo[FunctionName]>,
	timeout?: number,
): SendMessageReturnValue<ServiceWorkerFunctionInfo[FunctionName]> {
	const messageTransport: MessageTransport<ServiceWorkerFunctionInfo[FunctionName]> = {
		...message,
	};

	return new Promise((resolve, reject) => {
		let timer: ReturnType<typeof setTimeout> | undefined;
		if (timeout) {
			timer = setTimeout(() => {
				reject(new Error(`sendMessage timed out after ${timeout} ms`));
			}, timeout);
		}

		if (globalThis?.chrome?.runtime) {
			chrome.runtime.sendMessage(
				message.extensionId,
				messageTransport,
				{},
				(response: SendMessageReturnValue<ServiceWorkerFunctionInfo[FunctionName]>) => {
					const error = chrome.runtime.lastError;
					if (error) {
						if (timer) {
							clearTimeout(timer);
						}
						reject(error);
					}
					if (timer) {
						clearTimeout(timer);
					}
					resolve(response);
				},
			);
		} else {
			if (timer) {
				clearTimeout(timer);
			}
			reject();
		}
	});
}
